import { Box, Button, Container, Grid, Typography } from "@mui/material"
import { useApiDelete, useApiGet, useApiPut, useApiPost } from "auth/useApi2"
import ContinueDialog from "components/Dialogs/ContinueDialog"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { EquipmentForm } from "../../components/EquipmentForm"
import { useTranslation } from "react-i18next"

const EquipmentEdit = ({ match }) => {
  const { t } = useTranslation()
  const routerHistory = useHistory()
  const [equipmentResult, getEquiptment] = useApiGet()
  const [editEquipmentResult, editEquipment] = useApiPut()
  const [addEquipmentResult, addEquipment] = useApiPost()
  const loadingContext = useContext(GlobalLoaderContext)

  const [companyResult, getCompany] = useApiGet()
  const [storagesResult, getStorages] = useApiGet()
  const [devicesResult, getDevices] = useApiGet()
  const [equipmentStatuses, getEquipmentStatuses] = useApiGet()
  const [externalDeviceResult, getExternalDevice] = useApiGet()
  const [deleteResult, deleteEquipment] = useApiDelete()
  const [deleteDialogOpen, setDeleteDialog] = useState(false)
  const [noExternalDeviceId, setNoExternalDeviceId] = useState()

  const editWhenIdExists = (values) => {
    return {
      ...values
      // externalDeviceId: null
      // externalDeviceTypeId: values.externalDeviceTypeId,
      // system: "transportportalen",
      // externalDeviceSerialNumber: values.externalDeviceSerialNumber,
      // registrationNumber: values.registrationNumber,
      // hasTachograph: values.hasTachograph ?? false,
      // deviceTypeConfigurationId: values.externalConfigId,
      // companyCardId: null,
      // apn: null,
      // companyId: values.companyId,
      // equipmentDescription: values.equipmentDescription,
      // equipmentId: values.equipmentId,
      // status: values.status,
      // equipmentTypeId: values.equipmentTypeId,
      // subscriptionTime: values.subscriptionTime,
      // mountedOnDeviceId: values.mountedOnDeviceId,
      // mountedOnStorageId: values.mountedOnStorageId,
      // hasConnectToDevice: values.hasConnectToDevice,
      // supplements: values.supplements
    }
  }

  const editWhenIdDontExists = (values) => {
    // const payload = { ...values }
    // delete payload.ioPriority
    // delete payload.positionPriority
    // return payload
    return {
      ...values,
      ioPriority: true,
      positionPriority: true
    }
  }

  const handleSubmit = (values) => {
    if (noExternalDeviceId) {
      editEquipment(apiEndpoints.systemadmindeviceregistry.updateequipment, editWhenIdDontExists(values))
    } else {
      editEquipment(apiEndpoints.systemadmindeviceregistry.updateequipment, editWhenIdExists(values))
    }
  }

  useEffect(() => {
    getEquiptment(apiEndpoints.systemadmindeviceregistry.getequipmentbyid.replace("{id}", match.params.id))
    getCompany(apiEndpoints.systemadmindeviceregistry.listcompanies)
    getStorages(apiEndpoints.systemadmindeviceregistry.liststorages)
    getDevices(apiEndpoints.systemadmindeviceregistry.listdevices)
    getEquipmentStatuses(apiEndpoints.systemadmindeviceregistry.getequipmentstatuses)
    getExternalDevice(apiEndpoints.systemadmindeviceregistry.listexternaldeviceregistrydevicetypes)
  }, [getCompany, getDevices, getStorages, getEquipmentStatuses, getExternalDevice, match.params.id])

  useEffect(() => {
    loadingContext.setLoading(() => companyResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => storagesResult.status === 1)
  })

  useEffect(() => {
    loadingContext.setLoading(() => equipmentStatuses.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => equipmentResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => externalDeviceResult.status === 1)
  })

  const feedback = {
    errorTitle: t("global.equipment_could_not_be_created", "Equipment could not be created")
  }

  // delete row
  const handleDelete = () => {
    deleteEquipment(
      apiEndpoints.systemadmindeviceregistry.deleteequipment.replace("{id}", equipmentResult.data.id)
    )
  }
  useEffect(() => {
    if (deleteResult.status === 2) {
      routerHistory.push(allRoutes.SystemadminDevicesEquipment())
    }
  }, [deleteResult])

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminDevicesEquipment(),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        {deleteDialogOpen && (
          <ContinueDialog
            setShowContinueModal={setDeleteDialog}
            onAddSubmit={handleDelete}
            message={`Vill du ta bort utrustning?`}
            continueBtnText="Ta bort utrustning"
            cancelBtnText={t("global.cancel", "Cancel")}
            result={deleteResult}
          />
        )}

        <Box marginY={3}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Typography variant="h2">Redigera utrustning</Typography>
          </Grid>
        </Box>
        {companyResult.status === 2 &&
          equipmentStatuses.status === 2 &&
          storagesResult.status === 2 &&
          equipmentResult.status === 2 &&
          externalDeviceResult.status === 2 && (
            <EquipmentForm
              companyResult={companyResult}
              storagesResult={storagesResult}
              devicesResult={devicesResult}
              externalDeviceResult={externalDeviceResult}
              equipmentStatuses={equipmentStatuses}
              onSubmit={handleSubmit}
              feedback={feedback}
              editEquipment={equipmentResult.data}
              result={editEquipmentResult}
              setNoExternalDeviceId={setNoExternalDeviceId}
              noExternalDeviceId={noExternalDeviceId}
            />
          )}
        <Button onClick={() => setDeleteDialog(true)} variant="contained" color="primary">
          Ta bort utrustning
        </Button>
      </Container>
    </div>
  )
}

export default EquipmentEdit
